/**
 * [1:1] Whether a SOF order is on hold — case-insensitive match of the
 * OrderStatus value against 'on hold', as in the old MVC app.
 *
 * @param orderStatus - The raw OrderStatus value from the API.
 * @returns True when the order is on hold.
 */
export function isOnHold(orderStatus: string | null | undefined): boolean {
  return orderStatus?.toLowerCase() === 'on hold';
}
